import moment from "moment";
import store from "../../store";
export default {
  methods: {
    setToLocaleString(val, decimal = 2) {
      if (val) {
        return parseFloat(val).toLocaleString("en-US", {
          minimumFractionDigits: decimal,
          maximumFractionDigits: decimal,
          // return parseInt(val).toLocaleString(undefined, {
          //   minimumFractionDigits: decimal,
        });
      }
      return 0;
    },

    formatDate(val, dateFormat = "MMM DD, YYYY") {
      return moment(val).format(dateFormat);
    },

    trimMobileNumber(num) {
      return num.replace(/\s+/g, "").replace("+", "");
    },

    getLabel(val1, val2, verifier, approver) {
      return val1 === val2 ? verifier : approver;
    },

    hasPermission(permission, level) {
      let { adminLogin } = store?.getters.userData;

      console.log("role", adminLogin.roles);
      console.log("permisi", permission)
      console.log(adminLogin.roles[0].length > 0);
      if (adminLogin.roles.length > 0) {
        let p = adminLogin.roles[0]?.permissions?.filter(function(pr) {
          return pr.code == permission;
        });

        console.log("p", p);

        if (p[0]?.level?.indexOf(level) >= 0) {
          return true;
        }
      }
      return false;
    },
  },
};
